import '../../common_screen/home_tab/index.css';
import { Text, View } from '../../../component';
import ContestTab from '../contest_tab';
import MyContestTab from '../my_contest_tab';
import { HomeTabBar } from '../../component';
import SwipeableViews from 'react-swipeable-views';
import MyAnswers from '../my_answer_tab';
import DefaultContainer from '../../../container/default_container';
import useTheme from '../../../utilities/hooks/theme';
import { isMatchInScheduled } from '../../../utilities/helper';
import Constants from '../../../constants';
import { CounterWrapper } from '../../../component/header_with_timer';

const HomeTabWeb = ({
  activeTab,
  routes,
  myContestList,
  matchItem,
  gameType,
  onCalledDeadline,
  onChangeIndex,
  onChangeTab,
  totalTeamsCount
}: any) => {
  const renderHeader = (matchItem: any, onCalledDeadline: any, gameType: any) => {
    const { ComponentTheme } = useTheme();

    const {
      teamA = {},
      teamB = {},
      status: matchStatus,
      verified,
      gameState = 0,
      matchDelayed = false
    } = matchItem;

    const matchTitleTextColor = {
      color: ComponentTheme.headerTitle
    };

    const isMatchScheduled = isMatchInScheduled({
      matchStatus,
      gameState,
      matchDelayed,
      gameType
    });

    const timerIconDimension = '20px';

    return (
      <>
        <div className="fantasy-cricket-header-with-timer-wrapper">
          <View className="fantasy_cricket_header_timer_wrapper">
            {isMatchScheduled && (
              <View className="header-with-timer-icon-wrapper">
                <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
              </View>
            )}
            {
              <CounterWrapper
                onCalledDeadline={onCalledDeadline}
                matchStatus={matchStatus}
                verified={verified}
                matchItem={matchItem}
                isMatchScheduled={isMatchScheduled}
                gameType={gameType}
              />
            }
          </View>

          <Text style={matchTitleTextColor} className="fantasy-cricketheader-with-timer-title">
            {`${teamA?.name} vs  ${teamB?.name}`}
          </Text>
        </div>
      </>
    );
  };

  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="home_tab_wrapper">
        <div className="fantasy-cricket-primary-container">
          {renderHeader(matchItem, onCalledDeadline, gameType)}
          <div className="fantasy__homeTab__wrapper ">
            <HomeTabBar
              myTeamCount={totalTeamsCount}
              myContestsCount={myContestList[matchItem._id]?.length}
              activeTab={activeTab}
              onChangeTab={onChangeTab}
              routes={routes}
            />
          </div>
        </div>
        <SwipeableViews
          className="fantasy-cricket-secondary-container"
          style={{ height: '84%', alignItems: 'center !important', overflowY: 'scroll' }}
          disableLazyLoading={true}
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <ContestTab />
          <MyContestTab onPressChangeTab={onChangeIndex} />
          <MyAnswers />
        </SwipeableViews>
      </div>
    </DefaultContainer>
  );
};

export default HomeTabWeb;
